import PDFDict from 'PDFLib/core/objects/PDFDict';
import PDFAcroChoice from 'PDFLib/core/acroform/PDFAcroChoice';
import PDFContext from 'PDFLib/core/PDFContext';
import PDFRef from 'PDFLib/core/objects/PDFRef';
import { AcroChoiceFlags } from 'PDFLib/core/acroform/flags';

class PDFAcroComboBox extends PDFAcroChoice {
  static fromDict = (dict: PDFDict, ref: PDFRef) =>
    new PDFAcroComboBox(dict, ref);

  static create = (context: PDFContext) => {
    const dict = context.obj({
      FT: 'Ch',
      Ff: AcroChoiceFlags.Combo,
      Kids: [],
    });
    const ref = context.register(dict);
    return new PDFAcroComboBox(dict, ref);
  };
}

export default PDFAcroComboBox;
